<template>
  <div v-if="version === 'v1'" class="n-blog-card shine-effect tw-group" :style="isSidebar ? 'min-height: 500px;' : ''">
    <nuxt-link :to="`/blogs/${blog.url}`" :external="true" class="!tw-p-0">
      <div class="tw-relative tw-overflow-hidden">
        <library-image
          class="tw-transition-all tw-duration-500 group-hover:tw-scale-110"
          :src="blog.largeImage"
          :title="blog.title"
          :alt="blog.title"
          :w-ratio="16"
          :h-ratio="9"
        />
        <div
          class="shine tw-absolute tw-inset-0 tw-bg-black tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-20"
          style="border-radius: var(--rounded)"
        ></div>
      </div>
      <h4
        class="tw-mt-8 tw-line-clamp-3 tw-h-[90px]"
        :style="`color: var(--c-${textColor || 'text_primary'}) !important`"
      >
        {{ blog.title }}
      </h4>
      <p class="tw-mt-4" :style="`color: var(--c-${textColor || 'text_primary'}) !important`">
        {{ blog.description }}
      </p>
      <button class="outlined tw-mt-4 !tw-justify-start" :class="`n-${buttonTypeText || 'quaternary'}`">
        VIEW MORE
         <span v-if="buttonTypeText?.toString().includes('secondary icon')" class="btn-arrow">
            <svg width="23" height="9" viewBox="0 0 23 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M22.3536 4.85355C22.5488 4.65829 22.5488 4.34171 22.3536 4.14645L19.1716 0.964466C18.9763 0.769204 18.6597 0.769204 18.4645 0.964466C18.2692 1.15973 18.2692 1.47631 18.4645 1.67157L21.2929 4.5L18.4645 7.32843C18.2692 7.52369 18.2692 7.84027 18.4645 8.03553C18.6597 8.2308 18.9763 8.2308 19.1716 8.03553L22.3536 4.85355ZM0 4.5V5H22V4.5V4H0V4.5Z"
                fill="var(--c-text_primary)"
              />
            </svg>
          </span>
      </button>
    </nuxt-link>
  </div>

  <div v-if="version === 'v2'" class="shine-effect tw-group">
    <nuxt-link :to="`/blogs/${blog.url}`" :external="true" class="n-link n-blog-card !tw-p-0">
      <div class="tw-relative">
        <library-image :src="blog.largeImage" :title="blog.title" :alt="blog.title" :w-ratio="16" :h-ratio="9" />
        <div
          class="shine tw-absolute tw-inset-0 tw-bg-black tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-20"
          style="border-radius: var(--rounded)"
        ></div>
      </div>
      <h4 class="tw-mt-8 tw-line-clamp-3 tw-h-[100px] !tw-text-black">{{ blog.title }}</h4>
      <p class="tw-mt-4 !tw-text-black tw-min-h-[144px] tw-line-clamp-6">{{ blog.description }}</p>
      <button v-if="company?.company_key !== 'keystonepmc'" class="n-primary outlined tw-mt-4 !tw-justify-start">
        VIEW MORE 
        <span class="btn-arrow"> </span>
      </button>

      <button v-else class="n-link n-secondary icon blue tw-mt-4 !tw-justify-start">
        VIEW THIS BLOG
        <svg width="23" height="9" viewBox="0 0 23 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.3536 4.85355C22.5488 4.65829 22.5488 4.34171 22.3536 4.14645L19.1716 0.964466C18.9763 0.769204 18.6597 0.769204 18.4645 0.964466C18.2692 1.15973 18.2692 1.47631 18.4645 1.67157L21.2929 4.5L18.4645 7.32843C18.2692 7.52369 18.2692 7.84027 18.4645 8.03553C18.6597 8.2308 18.9763 8.2308 19.1716 8.03553L22.3536 4.85355ZM0 4.5V5H22V4.5V4H0V4.5Z" fill="var(--c-primary)"/></svg>
      </button>

    </nuxt-link>
  </div>

  <div v-if="version === 'v4'" class="shine-effect tw-group">
    <nuxt-link :to="`/blogs/${blog.url}`" :external="true" class="n-link n-blog-card !tw-p-0">
      <div class="tw-relative">
        <library-image :src="blog.largeImage" :title="blog.title" :alt="blog.title" :w-ratio="16" :h-ratio="9" />
        <div
          class="shine tw-absolute tw-inset-0 !tw-bg-black tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-20"
          style="border-radius: var(--rounded)"
        ></div>
      </div>
      <template v-if="variables?.textColor"> 
        <h4 class="tw-mt-8 tw-line-clamp-3 tw-h-[88px]" :style="`color: var(--c-${variables?.textColor}) !important`">{{ blog.title }}</h4>
        <p class="tw-mt-4" :style="`color: var(--c-${variables?.textColor}) !important`">{{ blog.description }}</p>
      </template>

      <template v-else>
        <h4 class="tw-mt-8 tw-line-clamp-3 tw-h-[88px] !tw-text-white">{{ blog.title }}</h4>
        <p class="tw-mt-4 !tw-text-white">{{ blog.description }}</p>
      </template>
     
    </nuxt-link>
  </div>

  <div v-if="version === 'v3'" class="shine-effect tw-group">
    <nuxt-link :to="`/blogs/${blog.url}`" :external="true" class="n-link n-blog-card !tw-p-0">
      <div class="tw-relative">
        <library-image :src="blog.largeImage" :title="blog.title" :alt="blog.title" :w-ratio="16" :h-ratio="9" />
        <div
          class="shine tw-absolute tw-inset-0 tw-bg-black tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-20"
          style="border-radius: var(--rounded)"
        ></div>
      </div>
      <h5 class="tw-mt-8 tw-line-clamp-3 tw-h-[75px]">{{ blog.title }}</h5>
      <p class="tw-mt-4">{{ blog.description }}</p>
    </nuxt-link>
  </div>

  <div v-if="version === 'static-v1'" class="n-blog-card tw-min-h-[563px] shine-effect tw-group" :style="isSidebar ? 'min-height: 500px;' : ''">
    <nuxt-link :to="`/blogs/${blog.link}`" :external="true" class="!tw-p-0">
      <div class="tw-relative tw-overflow-hidden">
        <library-image
          class="tw-transition-all tw-duration-500 group-hover:tw-scale-110"
          :src="blog.photo"
          :title="blog.title"
          :alt="blog.title"
          :w-ratio="16"
          :h-ratio="9"
        />
        <div
          class="shine tw-absolute tw-inset-0 tw-bg-black tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-20"
          style="border-radius: var(--rounded)"
        ></div>
      </div>
      <h4
        v-if="blog.title"
        class="tw-mt-8 tw-line-clamp-3 tw-h-[80px]"
        :style="`color: var(--c-${variables?.textColor || textColor}) !important`"
      >
        {{ blog.title }}
      </h4>
      <p v-if="blog.description" :style="`color: var(--c-${variables?.textColor || textColor}) !important`">
        {{ blog.description }}
      </p>
      <button class="tw-flex tw-items-center tw-gap-2 outlined tw-mt-6 !tw-justify-start n-link" :class="`n-${variables?.blogButtonTypeText || 'quaternary'}`">
        {{ variables?.blogButtonLabelText }}
        <span class="btn-arrow">
          <svg width="23" height="9" viewBox="0 0 23 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.3536 4.85355C22.5488 4.65829 22.5488 4.34171 22.3536 4.14645L19.1716 0.964466C18.9763 0.769204 18.6597 0.769204 18.4645 0.964466C18.2692 1.15973 18.2692 1.47631 18.4645 1.67157L21.2929 4.5L18.4645 7.32843C18.2692 7.52369 18.2692 7.84027 18.4645 8.03553C18.6597 8.2308 18.9763 8.2308 19.1716 8.03553L22.3536 4.85355ZM0 4.5V5H22V4.5V4H0V4.5Z" :fill="svgFillColor"/></svg>
        </span>
      </button>
    </nuxt-link>
  </div>

  <div v-if="version === 'v5'" class="n-blog-card shine-effect tw-group" :style="isSidebar ? 'min-height: 500px;' : ''">
    <nuxt-link :to="`/blogs/${blog.url}`" :external="true" class="!tw-p-0">
      <div class="tw-relative tw-overflow-hidden">
        <library-image
          class="tw-transition-all tw-duration-500 group-hover:tw-scale-110"
          :src="blog.largeImage"
          :title="blog.title"
          :alt="blog.title"
          :w-ratio="16"
          :h-ratio="9"
        />
        <div
          class="shine tw-absolute tw-inset-0 tw-bg-black tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-20"
          style="border-radius: var(--rounded)"
        ></div>
      </div>
      <h5
        class="tw-mt-8 tw-line-clamp-3 tw-h-[90px]"
        :style="`color: var(--c-${textColor || 'text_primary'}) !important`"
      >
        {{ blog.title }}
      </h5>
      <div class="tw-h-[140px]">
      <p class="tw-mt-4 tw-line-clamp-6" :style="`color: var(--c-${textColor || 'text_primary'}) !important`">
        {{ blog.description }}
      </p>
      </div>
      <button  class="tw-flex tw-items-center tw-gap-2 outlined tw-mt-4 !tw-justify-start n-link" :class="`n-${variables?.blogButtonTypeText || 'quaternary'}`">
        VIEW THIS BLOG
        <span class="btn-arrow">
          <svg width="23" height="9" viewBox="0 0 23 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.3536 4.85355C22.5488 4.65829 22.5488 4.34171 22.3536 4.14645L19.1716 0.964466C18.9763 0.769204 18.6597 0.769204 18.4645 0.964466C18.2692 1.15973 18.2692 1.47631 18.4645 1.67157L21.2929 4.5L18.4645 7.32843C18.2692 7.52369 18.2692 7.84027 18.4645 8.03553C18.6597 8.2308 18.9763 8.2308 19.1716 8.03553L22.3536 4.85355ZM0 4.5V5H22V4.5V4H0V4.5Z" :fill="svgFillColor"/></svg>
        </span>
      </button>
    </nuxt-link>
  </div>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { ComponentMixin } from '~/mixins/component.mixin';
import { version } from '~/public/theme2/js/webflow';
import { useWebsiteStore } from '~/units/website/store';
import { ROUTES } from '~/constants/ui.constants';

export default defineNuxtComponent({
  name: 'Theme7BlogCard',

  mixins: [ComponentMixin],

  props: {
    blog: {
      required: true,
    },
    index: {
      required: true,
      type: Number,
    },

    version: {
      type: String,
      default: 'v1',
    },

    variables: {
      type: Object,
    },

    isSidebar: {
      type: Boolean,
      default: false,
    },

    isLargeImg: {
      type: Boolean,
      default: false,
    },

    buttonTypeText: {
      type: String,
      default: 'quaternary',
    },

    textColor: {
      type: String,
      default: 'text_primary',
    },
  },

  computed: {
    ...mapState(useWebsiteStore, ['company']),

    ROUTES() {
      return ROUTES;
    },
    buttons() {
      return this.groupedVariables.buttons;
    },
    
    svgFillColor() {
      if (this.vars?.backgroundColor === 'section_primary') {
        return 'var(--c-text_primary)';
      } else if (this.vars?.backgroundColor === 'section_secondary') {
        return 'var(--c-text_tertiary)';
      }
      return 'white'; // fallback
    },
  },
});
</script>
